import { Signal } from '@preact/signals-react';
import applicationDetailSignal, {
  ApplicationDetailType,
} from '../../ApplicationDetail/ApplicationDetail.signal';

export const handleApplicationSendBackNoteChange = (
  e: Record<string, string>
): Signal<ApplicationDetailType> => {
  const { value } = e;
  return applicationDetailSignal.update({ sendBackNoteBody: value });
};

export const handleApplicationStatusDropdownChange = (
  e: React.ChangeEvent<HTMLSelectElement>
): Signal<ApplicationDetailType> => {
  const { value } = e.target;
  return applicationDetailSignal.update({ newApplicationStatus: value });
};
